import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ContactUsSection from "@/app/pages/home/sections/contact/ContactSection";
import * as styles from "./home.module.css";
import ClientsSection from "./sections/clients/ClientsSection";
import HomeTopSection from "./sections/top/HomeTopSection";
import ServicesSection from "./sections/services/ServicesSection";
export default function Home() {
    return (_jsxs("main", { className: styles.home, children: [_jsx(HomeTopSection, {}), _jsx(ServicesSection, {}), _jsx(ClientsSection, {}), _jsx(ContactUsSection, {})] }));
}
